import { useState } from "react";
// import { fieldNames } from '../../components/PIForm/Steps/step3/utils'
import { fieldNames } from "../../components/creditInfoForm/steps/step3/utils";

const {
  DIRECTOR_FULL_NAME,
  COUNTRY,
  IDENTIFICATION_NUMBER,
  CITY,
  COUNTRY_CODE,
  LEGAL_FORM,
  CITY_VILLAGE,
  APARTMENT_NUMBER,
  HOME_NUMBER,
  STREET,
  IS_ACTUAL_ADDRESS,
  LEGAL_ADDRESS,
  ACTUAL_ADDRESS,
  VILLAGE,
  PEP,
  PEP_DESC,
  NAME_OF_COMPANY,
  AGREEMENT_HTML_BASED_ON_STEP_THREE,
} = fieldNames;

const initAddress = {
  [COUNTRY]: "",
  [CITY]: "",
  [STREET]: "",
  [CITY_VILLAGE]: "",
  [HOME_NUMBER]: "",
  [APARTMENT_NUMBER]: "",
  [VILLAGE]: "",
  [AGREEMENT_HTML_BASED_ON_STEP_THREE]: null,
};

const initState = {
  [DIRECTOR_FULL_NAME]: "",
  [LEGAL_FORM]: "2",
  [IDENTIFICATION_NUMBER]: "",
  [COUNTRY_CODE]: "",
  [IS_ACTUAL_ADDRESS]: false,
  [NAME_OF_COMPANY]: "",
  [PEP]: "no",
  [PEP_DESC]: "",
  [LEGAL_ADDRESS]: { ...initAddress },
  [ACTUAL_ADDRESS]: { ...initAddress },
};

function useStepThreeValues() {
  const [stepThreeValues, setStepThreeValues] = useState(initState);
  return { stepThreeValues, setStepThreeValues };
}

export default useStepThreeValues;
